module.exports = __webpack_public_path__ + "static/tac-1ff96aaedf66481f25be04ad00aea02f.png";